import { AUTH_TOKEN_NAME } from '../../../controllers/AutenticacaoController';

/** Lê uma claim qualquer do token. Não valida assinatura — quem valida é a API. */
function claimDoToken(nome: string): string | null {
  let token: string | null = null;

  try {
    token = localStorage.getItem(AUTH_TOKEN_NAME);
  } catch {
    return null;
  }

  if (!token) return null;

  const partes = token.split('.');
  if (partes.length !== 3) return null;

  try {
    let base64 = partes[1].replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4 !== 0) base64 += '=';

    const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    const dados = JSON.parse(new TextDecoder('utf-8').decode(bytes));
    const valor = dados?.[nome];

    return typeof valor === 'string' && valor.trim() !== '' ? valor : null;
  } catch {
    return null;
  }
}

/**
 * true quando a pessoa ainda está com a senha temporária e precisa cadastrar a dela.
 *
 * Lido do TOKEN, que é assinado: o navegador não consegue apagar a marca para escapar da
 * troca. E sobrevive ao F5 — se dependesse de estado em memória, recarregar a página
 * liberaria o sistema inteiro.
 */
export function estaEmPrimeiroAcesso(): boolean {
  return claimDoToken('PrimeiroAcesso') === 'S';
}

/**
 * O nome de quem está logado, lido do próprio token.
 *
 * POR QUE DO TOKEN, E NÃO DO AuthContext
 *
 * O `currentUser` do contexto só é preenchido no `signIn`. Depois de um F5 ele volta a
 * ser `null` — o `validateToken` não o repovoa —, e o nome sumiria da tela em toda
 * recarga. O token sobrevive à recarga e já carrega a claim `UserName`, então é a fonte
 * que não mente em nenhum dos dois momentos.
 *
 * Não valida assinatura nem precisa: aqui o conteúdo é usado só para EXIBIR. Quem confere
 * se o token é legítimo é a API, a cada requisição.
 */
export function nomeDoUsuarioLogado(): string | null {
  return claimDoToken('UserName') ?? claimDoToken('username');
}
